import styled from 'styled-components';

export const CookieBannerContainer = styled.div`
    background: ${props => props.theme.cookieBannerBackgroundColor};
    position: fixed;
    bottom: 0;
    width: 100%;

    &,
    & a {
        color: ${props => props.theme.cookieBannerTextColor};
    }

    & button.bt {
        background: ${props => props.theme.cookieBannerButtonColor};
        color: ${props => props.theme.cookieBannerTextColor};
        border-color: ${props => props.theme.cookieBannerButtonColor};
        font-size: 12px;
        font-weight: 900;
        width: 29px;
        height: 19px;
        padding: 0;
    }

    .link {
        margin: 0 5px 0 5px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/header/cookiebanner/CookieBannerComponentStyle.js